export default __webpack_public_path__ + "assets/images/25928685b17b336270fedef51bfc4612.svg";